<template>
  <v-dialog v-model="dialog" width="500" @click:outside="cancel" :persistent="isLoading">
    <v-card>

      <v-alert
        v-model="alertFlg"
        type="error"
        density="compact"
        :title=errorMsg
        :text="$t('common.message.retry')"
        closable
        class="ma-2"
      />

      <v-card-text
        class="pa-4 pre-line grey--text text--darken-4 text-subtitle-1 px-5"
      >
        <p v-if="dialogData.actionType === 0" class="mb-4">
          {{ $t('tanaoroshiConfirmDialog.message.comfirmClear') }}
        </p>
        <p v-if="dialogData.actionType === 1" class="mb-4">
          {{ $t('tanaoroshiConfirmDialog.message.confirmAndCooperate') }}
        </p>
        <p v-if="dialogData.actionType === 2" class="mb-4">
          {{ $t('tanaoroshiConfirmDialog.message.confirm') }}
          <br>
          <v-text style="color: #FF0000;">{{ $t('tanaoroshiConfirmDialog.message.confirmAnnotation') }}</v-text>
        </p>
        <p v-if="dialogData.actionType === 3" class="mb-4">
          {{ $t('tanaoroshiConfirmDialog.message.confirmAndCooperateApv') }}
        </p>
        <p v-if="this.isCsvDownload()" class="mb-4">
          {{ $t('tanaoroshiConfirmDialog.message.downloadCsv') }}
        </p>
        <template v-if="this.isForceConfirm()">
          <p class="mb-2">
            {{ dialogData.actionType === 7
              ? $t('tanaoroshiConfirmDialog.message.forceConfirmAndCooperateApv')
              : $t('tanaoroshiConfirmDialog.message.forceConfirm') }}
            <br>
            <v-text style="color: #FF0000;">{{ $t('tanaoroshiConfirmDialog.message.forceConfirmAnnotation') }}</v-text>
            <template v-if="dialogData.actionType === 6">
              <br>
              <v-text style="color: #FF0000;">{{ $t('tanaoroshiConfirmDialog.message.confirmAnnotation') }}</v-text>
            </template>
          </p>
          <div class="mb-4">
            <div class="font-weight-bold">{{ $t('tanaoroshiConfirmDialog.label.unsavedTerminal') }}</div>
            <div v-for="t in unsavedTerminalList" :key="t.htSerial" class="ml-2">
              {{ t.htSerial }}
              （{{ $t('tanaoroshiConfirmDialog.label.lastReadDatetime') }}：{{ t.lastReadDatetime || "-" }}）
            </div>
          </div>
          <div v-if="unreadZoneList.length > 0" class="mb-4" style="color: #FF0000;">
            <div class="font-weight-bold">{{ $t('tanaoroshiConfirmDialog.message.forceConfirmUnreadZone') }}</div>
            <div v-for="z in unreadZoneList" :key="z.zoneId" class="ml-2">
              {{ z.zoneName }}（{{ z.readSuuryo }} / {{ z.planSuuryo }}）
            </div>
          </div>
        </template>

        <template
          v-if="dialogData.actionType === 1 || dialogData.actionType === 2 || dialogData.actionType === 3 || this.isForceConfirm()"
        >
          <div
            v-for="z in dialogData.tanaoroshi.zoneList"
            :key="z.zoneId"
            class="text-h6 d-flex justify-end mb-1"
          >
            <span>{{ z.zoneName }}</span>
            <span>{{ z.readSuuryo }} / {{ z.planSuuryo }}</span>
            <span>({{ z.readPrecision }})</span>
          </div>
          <v-text-field
            density="compact"
            variant="outlined"
            hide-details="auto"
            v-model="staffCode"
            :label="$t('tanaoroshiConfirmDialog.label.staffCode')"
            :counter="staffCodeLength"
            :maxLength="staffCodeLength"
            :disabled="isLoading"
            :rules="[rules.checkStaffCode]"
          />
        </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="cancel" :disabled="isLoading"> {{ $t('common.action.cancel') }} </v-btn>
          <v-btn
            color="indigo darken-1"
            dark
            @click="ok"
            :loading="isLoading"
            :disabled="invalidInput"
          >
          {{ $t('common.action.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
import api from "@/apis/staff";
import constant from "@/utils/constant"
import utils from "@/utils";

export default {
  props: {
    dialogData: {
      type: Object, 
      required: true, 
    },
    handleOk: {
      type: Function,
      required: true, 
    },
    handleCancel: {
      type: Function,
      required: true,
    },
  },
  computed: {
    // 連携時の警告メッセージ
    coopWarn() {
      if(this.dialogData.tanaoroshi?.confirmedDatetime == null || this.dialogData.tanaoroshi?.confirmedDatetime.length != 14) return {flag: false, date: 0}
      const warnDaySub = Math.floor((new Date() - new Date(this.dialogData.tanaoroshi.confirmedDatetime.substring(0,4), parseInt(this.dialogData.tanaoroshi.confirmedDatetime.substring(4,6)) - 1, this.dialogData.tanaoroshi.confirmedDatetime.substring(6,8))) / 86400000)
      return {
        date: warnDaySub,
        flag: warnDaySub > constant.TANA_CONFIRM_WARN_THRESHOLD ? true : false
      };
    },
    
    // 強制確定時：予定数があるのに読取数が0のゾーン（確定すると在庫が0になる）
    unreadZoneList() {
      if (!this.isForceConfirm()) return [];
      return (this.dialogData.tanaoroshi?.zoneList ?? [])
        .filter(z => Number(z.planSuuryo) > 0 && Number(z.readSuuryo) == 0);
    },

    // validation
    invalidInput(){
      if (this.isCsvDownload()) return false;
      if (!this.isValidStaffCode(this.staffCode)) return true;
      if((this.staffCode.length > 0 && this.staffCode.length <= this.staffCodeLength)) return false;
      return true;
    },
  },
  data() {
    return {
      staffCode: "",
      dialog: true,
      isLoading: false,
      errorMsg: "",
      alertFlg: false,
      coopWarning: false,
      coopDateSub: 2,
      staffCodeLength: 0,
      // 強制確定時の未保存端末
      unsavedTerminalList: [],
      rules: {
        checkStaffCode: v => {
          return this.isValidStaffCode(v) || this.$t('tanaoroshiConfirmDialog.validation.halfAlnum');
        },
      },
    };
  },
  watch: {
    "dialogData.tanaoroshi": function () {
      this.errorMsg = "";
      this.staffCode = "";
    },
  },
  mounted() {
    this.staffCodeLength = constant.STAFF_CODE_MAX_LENGTH;
    if (this.isForceConfirm()) this.fetchUnsavedTerminalList();
  },
  methods: {
    isValidStaffCode(v) {
      return /^[0-9A-Za-z]*$/.test(v);
    },
    isCsvDownload() {
      return this.dialogData.actionType == 4;
    },
    // 強制確定（6：強制確定のみ、7：強制確定＋APV連携）
    isForceConfirm() {
      return this.dialogData.actionType == 6 || this.dialogData.actionType == 7;
    },
    // 未保存（実施中）の端末を取得
    fetchUnsavedTerminalList() {
      api.post("/tanaoroshi/terminal-status/search", {
        tanaoroshiId: this.dialogData?.tanaoroshi.tanaoroshiId ?? null,
        shopCode: this.dialogData?.shopCode ?? "",
      })
        .then((response) => {
          if (response.data?.status != 0) return;
          this.unsavedTerminalList = (response.data.results?.terminalList ?? [])
            .filter(x => x.savedDatetime == null)
            .map(x => ({ ...x, lastReadDatetime: utils.putSplitWordToCalendarWithTime(x.lastReadDatetime) }));
        })
        .catch((error) => {
          // do nothing（確定時にサーバ側でチェックする）
        });
    },
    cancel() {
      if(this.isLoading) return;
      this.handleCancel();
    },
    ok() {
      this.isLoading = true;

      if (this.isCsvDownload()) {
        this.downloadCsv();
        return;
      }
      //apiに突っ込む
      api.post(this.isForceConfirm() ? "/tanaoroshi/force-confirm" : "/tanaoroshi/confirm", {
        tanaoroshiId: this.dialogData?.tanaoroshi.tanaoroshiId ?? null,
        staffId: this.staffCode,
        shopCode: this.dialogData?.shopCode ?? "",
        releyFlag: (this.dialogData?.actionType == 3 || this.dialogData?.actionType == 7) ? 1 : 0,
      })
        .then((response) => {

          this.isLoading = false;
          if(response.data?.status == 0) {
            this.errorMsg = "";
            this.handleOk(this.dialogData.actionType);
          }
          else {  
            this.errorMsg = response.data?.errorMessage;
            this.alertFlg = true;
          }

        })
        .catch((error) => {
          //do nothing
          this.isLoading = false;
          if(error.response?.status == 404) this.errorMsg = this.$t('common.message.notFound');
          else if(error.response?.status == 400) this.errorMsg = error.response.data.errorMessage;
          else if(error.response?.data?.status == 1) this.errorMsg = this.$t('tanaoroshiConfirmDialog.message.error');
          else this.errorMsg = this.$t('tanaoroshiConfirmDialog.message.unknownError');
          this.alertFlg = true;
        });
    },
    // CSVダウンロード処理
    downloadCsv() {
      api.post("/tanaoroshi/download-csv", { tanaoroshiId: this.dialogData.tanaoroshi.tanaoroshiId })
        .then((response) => {

          if (response.status == 1) return;

          let dataArr = [];

          response.data.results.csvRecordList.forEach(element => {
            dataArr.push(element.join(",") + "\r\n");
          });
          const stamp = utils.csvTimeStamp(new Date())
          const prefix = this.$t('tanaoroshiConfirmDialog.fileNamePrefix.csv');
          utils.csvDownload(dataArr.join(""), `${prefix}${stamp}`);

          this.isLoading = false;
          this.errorMsg = "";
          this.handleOk(this.dialogData.actionType);
        })
        .catch((error) => {
          this.isLoading = false;this.errorMsg = this.$t('common.message.unknownError');
          this.alertFlg = true;
        })
    }
  },
};
</script>
<style>
.pre-line {
  white-space: pre-line;
}
</style>
